import React, { useState } from "react"
import { TextField } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useAppLocalization } from "../../../../modules/localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { sanitizeSearchQuery } from "../../../../lib/stringLib"

const useStyles = makeStyles()(() => ({
    input: {
        width: "20rem",
    },
}))

type StandardEmailFilterProps = Readonly<{
    value?: string
    onChange: (value?: string) => void
}>

export function StandardEmailFilter({ value, onChange }: StandardEmailFilterProps) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const [error, setError] = useState<string | null>(null)

    const validateEmail = (value: string) => {
        if (value === "") {
            return null
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(value)) {
            return l10n.getString("standard-email-filter-error-message")
        }
        return null
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = sanitizeSearchQuery(e.target.value)
        onChange(value)
        const validationError = validateEmail(value)
        setError(validationError)
    }

    return (
        <LocalizedStrict id="standard-email-filter-label" attrs={{ label: true }}>
            <TextField
                className={classes.input}
                error={!!error}
                helperText={error}
                type="email"
                value={value}
                label="Email"
                onChange={handleChange}
            />
        </LocalizedStrict>
    )
}
